// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Ach } from './ach';
import { ConfirmationPaymentMethod } from './confirmation-payment-method';
import { ConfirmationType } from './confirmation-type';
import { Dealer } from './dealer';
import { Order } from './order';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Confirmation extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  acknowledged?: Date;
  acknowledgedBy?: string;
  approved?: Date;
  cancelReason?: string;
  code!: string;
  confirmationPaymentMethodId?: number;
  confirmedBy?: string;
  created!: Date;
  createdBy?: string;
  dealerId!: number;
  declined?: Date;
  deleted?: Date;
  message?: string;
  message2?: string;
  messageName?: string;
  notes?: string;
  orderId?: number;
  paymentMethod?: string;
  remoteIPAddress?: string;
  requestedSalesRepContact!: boolean;
  salesRepConfirmation!: boolean;
  typeId!: number;
  viewed?: Date;
  aches!: Ach[];
  confirmationPaymentMethod!: ConfirmationPaymentMethod;
  dealer!: Dealer;
  order!: Order;
  type!: ConfirmationType;
}

